import { useCallback, useState } from 'react';
import { ILocation } from '../../../types/location';

export interface IUseLocationSuggestPopup {
  onLocationChange(location?: ILocation): void;
}
export const useLocationSuggestPopup = ({ onLocationChange }: IUseLocationSuggestPopup) => {
  const [isSuggestShown, setIsSuggestShown] = useState(false);

  const togglePopup = useCallback((state: boolean) => setIsSuggestShown(state), []);

  const onItemClick = useCallback(
    (location: ILocation) => {
      onLocationChange(location);
      setIsSuggestShown(false);
    },
    [onLocationChange],
  );

  return {
    togglePopup,
    onItemClick,
    isSuggestShown,
  };
};
